function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "d-1",
  x1: 27.59,
  y1: 163.17,
  x2: 106.09,
  y2: 199.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#44484b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d-2",
  x1: 0.59,
  y1: 110.59,
  x2: 100.59,
  y2: 110.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#11cebb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#11a9bb"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "logo-path1",
  d: "M53.91,110.59,6.83,207.67c-3,6.76-.35,11.5,5.36,12.92H88.25c8.92,0,14.89-8.44,11.26-15.93Z",
  transform: "translate(-0.59 -0.59)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "logo-path2",
  d: "M6.83,207.67l47.08-97.08,45.6-94.07C103.14,9,97.17.59,88.25.59H12.19A11.46,11.46,0,0,0,.59,11.92V206.75c0,7.4,5.15,13.93,11.6,13.84C6.48,219.17,3.85,214.43,6.83,207.67Z",
  transform: "translate(-0.59 -0.59)"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 220",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.5dab01be.svg";
export { ForwardRef as ReactComponent };